import { CompRef } from '@wix/document-services-types';
import {
  WidgetPointer,
  PluginActionContext,
} from '@wix/editor-platform-host-integration-apis';

import { PlatformContext } from '../../../types/platformApi';
import { extendPluginActionContext } from './utils';
import { PluginHostApi } from './types';
import { SlotPointer } from './slotPointer';

export class PluginService {
  hostAPI: PluginHostApi;

  constructor(hostAPI: PluginHostApi) {
    this.hostAPI = hostAPI;
  }

  public isPluginComponent(widgetPluginCompRef: CompRef) {
    return this.hostAPI.isPluginComponent(widgetPluginCompRef);
  }

  public async showOnPage(slotPointer: SlotPointer): Promise<void> {
    return this.hostAPI.showOnPage(slotPointer);
  }

  public async installWidgetPlugin(
    context: PlatformContext,
    slotPointer: SlotPointer,
    widgetRef: WidgetPointer,
    pluginActionContext: PluginActionContext,
  ): Promise<CompRef> {
    const actionContext = extendPluginActionContext(pluginActionContext);
    return this.hostAPI.installWidgetPlugin(
      context,
      slotPointer,
      widgetRef,
      actionContext,
    );
  }

  public async uninstallWidgetPlugin(
    context: PlatformContext,
    slotPointer: SlotPointer,
    pluginActionContext: PluginActionContext,
  ): Promise<void> {
    const actionContext = extendPluginActionContext(pluginActionContext);
    return this.hostAPI.uninstallWidgetPlugin(
      context,
      slotPointer,
      actionContext,
    );
  }
}
